import { Button } from '@mantine/core';

const PageView = ({ page, selected, pageSelectedHandler, href }) => {
  let label = 'Page ' + page;
  let ariaCurrent = null;
  let variant = 'outline';

  if (selected) {
    ariaCurrent = 'page';
    variant = 'filled';
    label = 'Page ' + page + ' is your current page';
  }

  return (
    <Button
      role="button"
      component="a"
      href={href}
      variant={variant}
      size="sm"
      tabIndex="0"
      aria-label={label}
      aria-current={ariaCurrent}
      onClick={pageSelectedHandler}
    >
      {page}
    </Button>
  );
};

export default PageView;
